import React from "react";
import { Field } from "redux-form";
import CountryCodeInput from "./CountryCodeInput";

export default function CountryCodeField(props) {
  return <Field component={CountryCodeInput} {...props} />;
}
